// extracted by mini-css-extract-plugin
module.exports = {"discount":"_1410bfd27b--discount--P2G6h"};